import { api } from '../api/api';

export const getClinicalRolesApi = async (username, nhName) => {
	const response = await api.get({
		path: `/get-clinical-roles?username=${username}`,
		params: { nhName: nhName?.trim() },
		service: 'useronboarding',
	});
	return response.data;
};

export const getClinicalDesignationApi = async (username, nhName) => {
	const response = await api.get({
		path: `/get-clinical-classification?username=${username}`,
		params: { nhName: nhName?.trim() },
		service: 'useronboarding',
	});
	return response.data;
};

export const getUserInfoByIdApi = async (id) => {
	const response = await api.get({
		path: `/getUserInfoById?id=${id}`,
		service: 'useronboarding',
	});
	return response.data;
};

export const submitMakerUserCreationApi = async (payload) => {
	const response = await api.post({
		path: '/makerusercreation',
		service: 'useronboarding',
		formdata: [payload],
	});
	return response.data;
};

export const checkExistingUsernameApi = async (username, nhName) => {
	const response = await api.get({
		path: '/check-existing-username',
		params: {
			username: username?.trim(),
			nhName: nhName?.trim(),
		},
		service: 'useronboarding',
	});
	return response.data;
};

/*
 * Modify NRIC APIs
 */
export const submitModifyNricApi = async (payload) => {
	const response = await api.post({
		path: '/modify-nric',
		service: 'useronboarding',
		formdata: payload,
	});

	return response.data;
};